declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '948783984216435'
let pixelLoaded = false

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq && pixelLoaded) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  script.onload = () => {
    pixelLoaded = true
  }
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCartAndRedirect(url: string) {
  // Fire the AddToCart event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Ex-Back AI',
      content_type: 'product',
      value: 7.0,
      currency: 'USD',
    })
  }

  // Also fire via image pixel as a reliable fallback
  try {
    const img = new Image()
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&cd[content_name]=Protocolo+Ex-Back+AI&cd[content_type]=product&cd[value]=7.00&cd[currency]=USD&noscript=1&t=${Date.now()}`
  } catch (e) {
    // silently fail
  }

  // Delay navigation to ensure pixel fires
  setTimeout(() => {
    window.location.href = url
  }, 500)
}
